import { render, staticRenderFns } from "./EmployeePersonEditor.vue?vue&type=template&id=65434b2d&scoped=true&"
import script from "./EmployeePersonEditor.vue?vue&type=script&lang=js&"
export * from "./EmployeePersonEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65434b2d",
  null
  
)

export default component.exports